import {AfterViewChecked, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {User} from '../../services/user/user';
import {UserService} from '../../services/user/user.service';
import * as _ from 'lodash';
import * as Constants from '../common-components/AppConstants';
import AppConstants, {BusinessType as BT} from '../common-components/AppConstants';
import {Carrier} from '../../services/carrier/carrier';
import {HhgCarrierRateFilingService} from '../../features/hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {LoadingService} from '../../services/loading/loading.service';
import {CarrierService} from '../../services/carrier/carrier.service';
import {AlertService} from '../../services/alert/alert.service';
import { RoutingStateService } from 'src/app/services/routing-state.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit, AfterViewChecked {
  activeItem = 'home';
  user: any;
  currentUser: User;
  currentUrl: any;
  isUserPresent = false;
  agency_auditor = Constants.agency_auditor_role;
  agency_admin = Constants.agency_admin_role;
  agency_user = Constants.agency_user;
  carrier_user = Constants.carrier_user;
  carrier_user_admin = Constants.carrier_user_admin;
  carrier_user_RF = Constants.carrier_user_RF;
  system_admin = Constants.system_admin;
  carrier: Carrier;
  HHG = BT.HHG;
  FRT = BT.FRT;
  HHG_FRT = BT.HHG_FRT;
  searchPhrase;
  carrier_frt_status_processing = Constants.carrier_frt_status_processing;

  constructor(public router: Router, private userService: UserService, private activatedRoute: ActivatedRoute, private loader: LoadingService,
              private hhgrateService: HhgCarrierRateFilingService, private carrierService: CarrierService, private alertService: AlertService,
              private cdRef: ChangeDetectorRef, private routingService: RoutingStateService) {
    this.currentUrl = location.pathname;
    // this method is used to get the user details, instead of calling to server every time, by using behavioural subject
    this.userService.getUserDetails().subscribe(currentUser => {
      if (AppConstants.isNotNullCondition(currentUser)) {
        this.currentUser = currentUser;
        console.log(this.currentUser);
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
        this.userService.setUserObservable(currentUser);
        const param = {lastName: currentUser.lastName, firstName: currentUser.firstName};
        this.userService.setParamObservable(param);
      }
    }, (error) => {
     // this.alertService.info('unable to get current user details');
    });
  }


  ngOnInit() {}

  openSearchApi() {
    const baseUrl = 'https://search.usa.gov/search?affiliate=usagov_all_gov&query=' + this.searchPhrase + '&commit=Search';
     window.open(baseUrl, "_blank");
  }

  checkUserRole(roles?) {
    if (this.currentUser) {
      const userRoles = _.map(this.currentUser.roles, x => x.role);
      if (userRoles && userRoles.length > 0) {
        return _.includes(userRoles, roles);
      }
    }
  }

  checkCarrierStatus(carrierStatus: String){
    if (AppConstants.isNotNullCondition(this.currentUser)) {
      return (this.currentUser?.carrierStatus === carrierStatus && this.currentUser?.permissions === Constants.BusinessType.FRT)? false : true;
    } return true;
  }

  /**
   * checking user permission to show the menu
   * @param: type
   */
  checkUserBusinessType(type?) {
    if (AppConstants.isNotNullCondition(this.currentUser)) {
      return this.currentUser.permissions === type;
    }
  }

  /**
   * checking if user is logged in
   */
  isLoggedIn() {
    this.router.events.subscribe((nav: NavigationEnd) => {
      if (AppConstants.isNotNullCondition(nav)) {
        this.currentUrl =  nav.url;
      }
    });
    this.isUserPresent = this.currentUrl !== '/userselection' && this.currentUrl !== '/termsAndConditions' && this.currentUrl !== '/' && this.currentUrl !== '/validatesso' && this.currentUrl !== '/customerregistration';
    if ( AppConstants.isNotNullCondition(localStorage.getItem('currentUser'))) {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      return this.currentUser !== null && this.currentUser !== undefined && this.currentUser.id !== null && this.currentUser.id !== undefined;
    }
  }

  // reloading page and re initiating the component
  goToSignon() {
    this.router.navigateByUrl('/signon').then(
        () => {
          location.reload();
        });
  }

  /**
   * Clear all bread crumb list
   */
  onNavClick() {
    this.routingService.clearBreadCrumbs();
  }

  onHeaderItemClick(itemName) {
    this.activeItem = itemName;
    console.log(itemName);
  }

  logout() {
    // removes user from session table
    this.userService.removeSession(this.currentUser);
    // remove user from local storage to log user out
    this.currentUser = null;
    this.isUserPresent = false;
    this.userService.logout('header');
    // this.router.navigate(['/signon']);
  }

  goToHHGShipmentReview() {
    this.router.navigate(['/shipmentreview'],
      { queryParams: { shipmentType: 'HHG' } });
  }

  goToFRTShipmentReview() {
    this.router.navigate(['/shipmentreview'],
      { queryParams: { shipmentType: 'FRT' } });
  }

  /**
   * re initiating the component to avoid errors on console, if from is frt, exeecuted the tsp rate participation logic
   */
  rateFilingChange(from) {
    this.loader.show();
    if (from === 'FRT') {
      this.hhgrateService.getCarrierByUser().subscribe((carrier: Carrier) => {
        if (carrier !== null && carrier !== undefined) {
          this.loader.hide();
          this.carrier = carrier;
          this.carrierService.setCarrierObservable(carrier);
          this.hhgrateService.getFrtTspStatus(this.carrier.carrierId).subscribe((res: String) => {
            this.loader.hide();
            if (res.toUpperCase() === 'ShowDunsScreen'.toUpperCase()) {
              this.router.navigateByUrl('/landing').then(
                () => {
                  this.routingService.clearBreadCrumbs();
                  this.router.navigate(['/duns'],
                    { queryParams: { rateType: from } });
                });
            } else if (res.toUpperCase() === 'ShowTspParticipationScreen'.toUpperCase()) {
              this.router.navigate(['/', 'tspParticipation']);
            } else if (res.toUpperCase() === 'ShowErrorMessage'.toUpperCase()) {
              this.alertService.information('Currently there is no open rate filing window or you may have rejected TSP participation, please contact system administrator!');
              this.router.navigate(['/', 'landing']);
            }
          }, error2 => {
            this.loader.hide();
            this.alertService.error('Error occurred while getting TSP rate participation status.');
          });
        }
      }, error => {
        this.loader.hide();
        this.alertService.error('Error while getting TSP Id. Please contact system administrator.');
      });
    } else {
      this.loader.hide();
      // when route was used once or more re initiating the duns
      this.router.navigateByUrl('/landing').then(
        () => {
          this.router.navigate(['/duns'],
            { queryParams: { rateType: from } });
        });
    }
  }

  // checking usersession exists
  userSession(currentUser) {
    if (AppConstants.isNotNullCondition(currentUser)) {
      return currentUser.userSessionEntity && currentUser.userSessionEntity.jSessionId;
    }
    return false;
  }

  // getting role name
  getRoleName(currentUser) {
    if (AppConstants.isNotNullCondition(currentUser) && AppConstants.isNotNullCondition(currentUser.userSessionEntity)) {
      const role = currentUser.roles.filter(x => x.id === currentUser.userSessionEntity.roleId);
      return role[0].role;
    }
    return  currentUser.roles[0] ? currentUser.roles[0].role : '';
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

}
